const checkedGamesFilter = allgames => {
  const checkedGames = allgames.filter(g => g.checked === true);

  return checkedGames;
};

export default checkedGamesFilter;
